import { useEffect } from 'react'
import configs from 'configs'
import { localStore, sessionStore } from 'utils/store'
import { cacheManager } from 'cache/cacheManager'
import { STORAGE_KEYS } from 'cache/keys'
import API from 'api'
import { useLocation } from 'react-router-dom'
import { NON_RESTORABLE_PATHS } from 'utils/constants'

const LogoutSync = () => {
  const location = useLocation()

  useEffect(() => {
    if (NON_RESTORABLE_PATHS.includes(location.pathname)) return

    sessionStore.set(STORAGE_KEYS.LAST_PATH, {
      path: location.pathname + location.search,
      slug: localStorage.getItem(STORAGE_KEYS.SLUG),
    })
  }, [location])

  useEffect(() => {
    if (location.pathname === '/login') return

    const checkToken = async () => {
      const apiServiceV2 = API().v2
      const token = localStore.get(configs.TOKEN_KEY)

      try {
        if (token) {
          await apiServiceV2.auth.validateToken(token)
        }
      } catch {
        cacheManager.clearPersistentAuth()
        cacheManager.clearPersistentAppState()

        window.location.href = '/login'
      }
    }

    checkToken()
  }, [location.pathname])

  return null
}

export default LogoutSync
